import React from "react";
import classNames from "classnames";
var MenuItem = function (_a) {
    var itemKey = _a.itemKey, currentKey = _a.currentKey, label = _a.label, disabled = _a.disabled, handleClick = _a.handleClick;
    var classes = classNames('menu-item', {
        'disabled': disabled,
        'active': currentKey === itemKey
    });
    return (React.createElement("li", { key: itemKey, className: classes, onClick: function () { return handleClick(itemKey); } }, label));
};
MenuItem.displayName = 'MenuItem';
export default MenuItem;
